// extracted by mini-css-extract-plugin
export default {"iconWrapper":"nxt-icon-button_iconWrapper__J0ZHx"};